document.addEventListener("DOMContentLoaded", function () {

  const imageCarousel = document.querySelector(".imageCarousel");

  if (imageCarousel) {
    const imageCarouselGlide = document.querySelector(".imageCarousel__glide.glide");
    let totalSlides = 0;

    if (imageCarouselGlide) {

      const svGlide = new Glide(imageCarouselGlide, {
        type: 'slider',
        // autoplay: 5000,
        perView: 2.2,
        perTouch: 1,
        dragThreshold: false,
        // startAt: 0,
        // focusAt: 0,
        // keyboard: false,
        // hoverpause: true,
        // bound: true,
        gap: 30,
        breakpoints: {
          768: {
            perView: 1.2,
            dragThreshold: 120,
          },
          480: {
            perView: 1.2,
            dragThreshold: 120,
          }
        }
      });

      svGlide.mount();

    }

  }
});
